import { render, staticRenderFns } from "./AddEmployee.vue?vue&type=template&id=5aefa1df&scoped=true&"
import script from "./AddEmployee.vue?vue&type=script&lang=js&"
export * from "./AddEmployee.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployee.vue?vue&type=style&index=0&id=5aefa1df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefa1df",
  null
  
)

export default component.exports